import React from 'react';
import { styled } from 'baseui';
import { getPixelSize, ICONSIZE } from './Icon';

export interface IconProps {
  iconSrc: string;
  alt: string;
  onClick: (event: React.MouseEvent<HTMLImageElement>) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLImageElement>) => void;
  size?: string;
  centered?: boolean;
  className?: string;
  disabled?: boolean;
  additionalTestId?: string;
}

const getCursor = (clickHandler: any) => {
  return clickHandler ? 'pointer' : 'default';
};

const IconView = styled('img', (props: Omit<any, '$theme'>) => ({
  maxWidth: getPixelSize(props.size),
  maxHeight: getPixelSize(props.size),
  margin: 'auto',
  cursor: getCursor(props.onClick),
  opacity: props.disabled ? '.5' : '1'
}));

const SelectableIcon: React.FC<IconProps> = (props: IconProps) => {
  return (
    <div className={`d-flex w-100 h-100 m-auto ${props.className}`}>
      <div
        className={`d-flex ${props.centered ? 'm-auto' : 'mt-0 mx-auto mb-auto'}`}
        style={{
          height: props.centered ? '100%' : getPixelSize(props.size),
          width: props.centered ? '100%' : getPixelSize(props.size)
        }}
      >
        <IconView
          tabIndex={0}
          src={props.iconSrc}
          onClick={props.onClick}
          onKeyDown={props.onKeyDown}
          size={props.size}
          centered={props.centered ? 1 : 0}
          disabled={props.disabled}
          alt={props.alt}
          data-gi={`img-btn${
            props.additionalTestId !== undefined ? ' ' + props.additionalTestId : ''
          }`}
        />
      </div>
    </div>
  );
};

SelectableIcon.defaultProps = {
  size: ICONSIZE.default,
  centered: false
};

export default SelectableIcon;
